/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import "./loader.css";

const Loader = () => {
  return (
    <div className="loader">
      <div className="svg-wrapper">
        {/* Add the following CSS for the flip animation */}
        <style>
          {`
            @keyframes flip {
              0% { transform: rotateY(0deg); }
              50% { transform: rotateY(180deg); }
              100% { transform: rotateY(360deg); }
            }

            .flipping {
              animation: flip 4s infinite; /* You can adjust the duration as needed */
            }
          `}
        </style>

        {/* The image element with the flipping class */}
        <img
          src="/assets/media/image/logo_small.png" // Replace with the path to your image
          alt="Loader"
          height="60"
          className="flipping"
        />

        <div className="loading-text">Loading...</div>
      </div>
    </div>
  );
};

export default Loader;
